/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { Row, Col, Button, Table, Card, CardBody } from "reactstrap";
import dayjs from "dayjs";
import logo from "../../Assets/images/logo.png";
import { getCookie } from "../../Helpers/Utils";
import { toast } from "react-toastify";

const QuotationView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [q, setQ] = useState(null);

    const loadQuotation = async () => {
        dispatch(loadingTrue());
        const res = await Handler({ method: "get", url: `/quotation/view.php?id=${id}` });
        if (res?.success) {
            setQ(res.data);
        }
        dispatch(loadingFalse());
    };

    const handlePdfPrint = () => {
        const token = getCookie("token");
        dispatch(loadingTrue());

        fetch(`${process.env.REACT_APP_API_URL || "https://sfsbill.dizoratbd.com/sfs-backend"}/quotation/generate_pdf.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ quotation_id: id })
        })
            .then(res => {
                if (!res.ok) throw new Error("Failed to generate PDF");
                return res.blob();
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = () => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    dispatch(loadingFalse());

                    setTimeout(() => {
                        URL.revokeObjectURL(url);
                        document.body.removeChild(iframe);
                    }, 5000);
                };
            })
            .catch(err => {
                toast.error("Error generating professional print");
                dispatch(loadingFalse());
            });
    };

    useEffect(() => { loadQuotation(); }, [id]);

    if (!q) return null;

    return (
        <div className="quotation-view-container p-4 bg-light min-vh-100">
            <div className="d-flex justify-content-between align-items-center mb-4 no-print">
                <Button color="secondary" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left"></i> Back
                </Button>
                <Button color="primary" onClick={handlePdfPrint}>
                    <i className="bi bi-printer"></i> Print Quotation
                </Button>
            </div>

            <Card className="shadow-sm border-0 mx-auto" style={{ maxWidth: "900px", minHeight: "297mm", padding: "40px" }}>
                <CardBody>
                    {/* Header Section Cleaned */}
                    <div className="d-flex justify-content-between align-items-center mb-5 border-bottom pb-4">
                        <img src={logo} alt="SFS Logo" style={{ height: "70px" }} />
                        <div className="text-end">
                            <h4 className="fw-bold text-dark mb-1">SEA FREIGHT SOLUTIONS PTE LTD</h4>
                            <p className="small text-muted mb-0">1 Sunview Road, #04-20 Eco-Tech @Sunview, Singapore 627615</p>
                            <p className="extra-small text-muted mb-0">GST Reg No: 201306380E</p>
                            <p className="extra-small text-muted">Tel: +65 8672 4777 | Email: admin@seafreightsolutions.sg</p>
                        </div>
                    </div>

                    <Row className="mb-4">
                        <Col md={7}>
                            <p className="mb-0 fw-bold text-muted small text-uppercase">To:</p>
                            <h5 className="fw-bold mb-1">{q.company_name}</h5>
                            <p className="small mb-1"><strong>Attention:</strong> Mr/Mrs</p>
                            <p className="small mb-1"><strong>Tel:</strong> {q.phone}</p>
                        </Col>
                        <Col md={5} className="text-md-end">
                            <h5 className="fw-bold text-primary mb-1 text-decoration-underline">QUOTATION</h5>
                            <p className="small mb-1"><strong>Quotation Ref:</strong> {q.quotation_number}</p>
                            <p className="small mb-1"><strong>Date:</strong> {dayjs(q.created_at).format("DD-MMM-YYYY")}</p>
                            <p className="small mb-1"><strong>Valid Until:</strong> {dayjs(q.valid_until).format("DD-MMM-YYYY")}</p>
                        </Col>
                    </Row>

                    <div className="mb-4">
                        <h6 className="fw-bold border-bottom pb-2">Ref: {q.ref || "Quotation for Supply of Transport Services."}</h6>
                        <p className="small mt-3">Dear Sir/Madam,</p>
                        <p className="small">We are pleased to submit herewith our quotation as follows:</p>
                    </div>

                    <Table bordered responsive className="text-center align-middle mb-2 small-table">
                        <thead className="table-dark">
                            <tr>
                                <th style={{ width: "25%" }}>LORRY TYPE</th>
                                <th>NORMAL OFFICE HOURS<br /><small>(0800HR to 1700HR)</small></th>
                                <th>AFTER OFFICE HOURS<br /><small>(1700HR to 0759HR)</small></th>
                                <th>SUNDAY / PUBLIC HOLIDAY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {q.items?.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="fw-bold text-start">
                                        {item.lorry_type}
                                    </td>
                                    <td>${parseFloat(item.normal_hours).toFixed(2)} / ${parseFloat(item.normal_hours_ot).toFixed(2)}/HR</td>
                                    <td>${parseFloat(item.after_office_hours).toFixed(2)} / ${parseFloat(item.offz_hours_ot).toFixed(2)}/HR</td>
                                    <td>${parseFloat(item.holiday_hours).toFixed(2)} / ${parseFloat(item.offz_hours_ot).toFixed(2)}/HR</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <p className="extra-small text-muted mb-4"><i>* PER TRIP 3 HRS / STANDBY CHARGES AFTER 3 HR</i></p>

                    <div className="bg-light p-3 rounded mb-4 border">
                        <h6 className="fw-bold extra-small text-uppercase border-bottom pb-1 mb-2">Additional Surcharges:</h6>
                        <Row className="small">
                            <Col md={6}>
                                <ul className="list-unstyled extra-small-text mb-0">
                                    <li>• Boarding Charges (PSA & All Shipyards): <b>$50.00</b></li>
                                    <li>• Jurong Island / Airport / KD Clearance: <b>$50.00</b></li>
                                    <li>• Shipyard Handling Charges: <b>$40.00</b></li>
                                    <li>• PSA / Jurong Port / Shipyards Entry: <b>+$20.00</b></li>
                                </ul>
                            </Col>
                            <Col md={6}>
                                <ul className="list-unstyled extra-small-text mb-0">
                                    <li>• SSN / DSA Creation (Per Doc): <b>$30.00</b></li>
                                    <li>• Administration Fee per Document: <b>$20.00</b></li>
                                    <li>• Extra Pickup Point: <b>Chargeable</b></li>
                                    <li>• Wharves/Crane Charges: <b>Not Included</b></li>
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    <div className="notes-section">
                        <h6 className="fw-bold text-decoration-underline mb-2 small">Note:</h6>
                        <ul className="extra-small-list ps-3 text-muted" style={{ fontSize: "0.75rem", lineHeight: "1.5" }}>
                            <li>Standard office hours: Mon-Fri (8:00 AM-5:00 PM), Sat (8:00 AM-12:00 PM).</li>
                            <li>Lorry transport based on per trip (03 hours) basis from point A to B.</li>
                            <li>Charges billed separately for each vessel if 2 or more load at the same time.</li>
                            <li>Cancellation within 2 hrs: <b>50% charge</b>. Onsite cancellation: <b>100% charge</b>.</li>
                            <li>Payment Due: <b>7 Days</b> from Invoice Date.</li>
                            <li>Rates are valid for <b>6 months</b> from the date of quotation.</li>
                        </ul>
                    </div>

                    <div className="mt-5 pt-4 text-center border-top">
                        <p className="small mb-4">We trust that the above will meet your approval and look forward to hearing from you soon.</p>

                        <div className="py-3 px-4 bg-light border rounded d-inline-block">
                            <p className="mb-0 fw-bold text-dark small">
                                <i className="bi bi-cpu-fill me-2"></i>
                                This is a system-generated quotation. No physical signature is required.
                            </p>
                        </div>

                        <div className="mt-4">
                            <h6 className="fw-bold mb-0">SEA FREIGHT SOLUTIONS PTE LTD</h6>
                            <p className="extra-small text-muted mb-0">Thank You</p>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <style>
                {`
                    @media print {
                        .no-print { display: none !important; }
                        body { background: white !important; padding: 0 !important; }
                        .card { box-shadow: none !important; border: none !important; padding: 0 !important; }
                        .quotation-view-container { padding: 0 !important; background: white !important; }
                    }
                    .small-table th { font-size: 0.7rem; vertical-align: middle; padding: 10px; }
                    .small-table td { font-size: 0.8rem; }
                    .extra-small-list li { margin-bottom: 4px; }
                    .extra-small-text li { margin-bottom: 2px; font-size: 0.75rem; }
                `}
            </style>
        </div>
    );
};

export default QuotationView;